import { render } from "./Transactions.vue?vue&type=template&id=467b7bd8"
import script from "./Transactions.vue?vue&type=script&lang=js"
export * from "./Transactions.vue?vue&type=script&lang=js"

import "./Transactions.vue?vue&type=style&index=0&id=467b7bd8&lang=css"
script.render = render

export default script